import { useEffect, useState } from "react";
import { Card, Col, Container, Form, Row, Spinner } from "react-bootstrap";
import { FaSave } from "react-icons/fa";
import { useAlertMessageContext } from "../../../contexts/alert-message.context";
import { useConfirmMessageContext } from "../../../contexts/confirm-message.context";
import cndService from "../../../services/cnd.service";
import { dateToString, notNullToDate } from "../../../utilities/auxiliary-functions";
import { removeFormatDate } from "../../../utilities/masks";
import { isEmpty } from "../../../utilities/validators";
import CommonAreaRecord from "../../records/common-area.record";
import { Button } from '@mui/material'
import { AlertMessageEnum } from "../../../utilities/types";
import { useTranslateContext } from "../../../contexts/translate.context";
import { usePartnerContext } from "../../../contexts/partner.context";
import authService from "../../../services/auth.service";
import FileResizer from "react-image-file-resizer";

export interface ICommonAreaCondominiumFormProps {
    title: string,
    identifier: string,
    setRecord: any,
    viewOnly?: boolean
}

export const CommonAreaCondominiumForm: React.FC<ICommonAreaCondominiumFormProps> = (props: ICommonAreaCondominiumFormProps) => {

    const alertContext = useAlertMessageContext();
    const confirmContext = useConfirmMessageContext();
    const { display } = useTranslateContext();
    let { partner } = usePartnerContext();

    const [ invalidatedForm, setInvalidatedForm ] = useState(false);
    const [ isEditForm, setEditForm ] = useState(true);

    let reloadPage = false;
    const [ isLoading, setLoading ] = useState(false);
    const [ originRecord, setOriginRecord ] = useState({} as any);
    const [ sending, setSending ] = useState(false);

    /* TRATAMENTO PARTICULAR DO OBJETO QUE ESTA SENDO MANTIDO */
    // CommonArea
    const [ commonAreaId, setCommonAreaId ] = useState(0);
    const [ name, setName ] = useState('');
    const [ observation, setObservation ] = useState('');
    const [ image, setImage ] = useState(''); 
    const [ created, setCreated ] = useState(dateToString(new Date(), 'dd/mm/yyyy HH:MM:ss'));
    const [ updated, setUpdated ] = useState(dateToString(new Date(), 'dd/mm/yyyy HH:MM:ss'));

    const [ listEstate, setListEstate ] = useState([] as any);

    function fillRecord(commonarea: any) {

        if (!isEmpty(commonarea)) {
            setCommonAreaId(commonarea.id);
            setName(commonarea.name);
            setObservation(commonarea.observation);
            setImage(commonarea.image);
            setCreated(notNullToDate(commonarea.created, 'dd/mm/yyyy HH:MM:ss'));  
            setUpdated(notNullToDate(commonarea.updated, 'dd/mm/yyyy HH:MM:ss'));  
        }
    } // fillRecord

    async function isValidForm() {
        let result = true;
        let emptyRequired = false;

        if (isEmpty(name))
            emptyRequired = true;
        /*
        if (isEmpty(registrationPf))
            emptyRequired = true;
        if ((!isEmpty(registrationPf)) && (!isCpf(registrationPf))) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, display.message.invalid.registration_pf);
            result = false;
        }
        */

        if (emptyRequired) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, display.message.invalid.required);
            result = false;
        }

        setInvalidatedForm(!result);
        return result;
    } // isValidForm

    function onClick_CancelCommonArea(event: any) {
        event.preventDefault();
        props.setRecord(event, 0);
    } // onClick_CancelCommonArea

    function fillRegister() {

        const dataRegister = {
            id : commonAreaId,
            partnerId: partner.id,
            name, 
            observation, 
            image,
            created : removeFormatDate(created), 
            updated : removeFormatDate(updated)
        };

        return dataRegister;
    } // fillRegister

    async function onClick_SaveCommonArea(event: any) {
        event.preventDefault();
        
        const isValid = await isValidForm();
        if (isValid) {
            try {
                const isConfirmed = await confirmContext.show(props.title, display.message.confirm_record);
                if (isConfirmed) {
                    setSending(true);

                    const commonarea = fillRegister();
                    if (commonarea.id > 0)
                        await cndService.saveCommonArea(commonarea.id, commonarea);
                    else
                        await cndService.createCommonArea(commonarea);

                    setSending(false);
                    await alertContext.show(AlertMessageEnum.SUCCESS, props.title, display.message.the_record_has_been_saved_successfully);
                    props.setRecord(event, 0);
                }
            } catch (error: any) {
                setSending(false);
                await alertContext.show(AlertMessageEnum.FAIL, props.title, error);
            }
        }
    } // onClick_SaveCommonArea
    
    async function changeEstate() {
        const attributes = ['id','name'];
        const result = await cndService.estateList(attributes);
        setListEstate(result.rows);
    }

    function changeImage(event: any) {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            const extension = String(file.name).substring(String(file.name).lastIndexOf('.') + 1, String(file.name).length);
            FileResizer.imageFileResizer(file, 300, 300, extension, 100, 0,
                (uri: any) => {
                    setImage(uri);
                }, "base64"
            );
        } else {
            setImage('');
        }
    }

    async function searchParam() {
        try {
            setEditForm(!props.viewOnly);
            if (!Number.isNaN(Number.parseInt(props.identifier ||''))) {

                const commonarea = await cndService.commonAreaById(Number(props.identifier));
                setOriginRecord(commonarea);
                fillRecord(commonarea);
            }
        } catch(error: any) {
            await alertContext.show(AlertMessageEnum.FAIL, props.title, error);
        }
    } // searchParam

    useEffect(() => {
        if (!isLoading && !reloadPage) {
            if (isEmpty(partner))
                // eslint-disable-next-line react-hooks/exhaustive-deps
                partner = authService.currentPartner();

            changeEstate();
            searchParam();
        }

        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            reloadPage = !reloadPage;
        }
    }, []); // useEffect

    function viewCadastreForm() {

        return (
            <Container fluid className="page-body commonarea">
                <Row>
                    <Col sm={12} className="page-sweet">
                        <Card>
                            <Card.Header>
                                {(originRecord.created || originRecord.updated) && (
                                    <div className="form-identy-registry float-right">
                                        <span className="white-space"><b>Criação: </b> {dateToString(originRecord.created, 'dd/mm/yyyy HH:MM:ss')}</span>
                                        <span className="white-space"><b>Atualização: </b> {dateToString(originRecord.updated, 'dd/mm/yyyy HH:MM:ss')}</span>
                                    </div>
                                )}
                                <Card.Title>{display.legend.record}</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Form className="form" id="form-cadastre" validated={invalidatedForm}>
                                    <CommonAreaRecord
                                        title={props.title}
                                        isEdit={isEditForm}
                                        identifier={commonAreaId === 0}
                                        viewOnly={props.viewOnly}

                                        created={created}
                                        updated={updated}

                                        name={name}
                                        observation={observation}
                                        setName={setName}
                                        setObservation={setObservation}
                                        image={image}
                                        changeImage={(event: any) => { changeImage(event); }} 
                                    />
                                </Form>
                            </Card.Body>
                            <Card.Footer className="text-right">
                                <Button className="me-2" onClick={ (e) => onClick_CancelCommonArea(e) } variant="contained" color="secondary">{display.buttom.cancel}</Button>
                                {!props.viewOnly && <Button onClick={ (e) => onClick_SaveCommonArea(e) } disabled={sending} variant="contained" color="primary">
                                    { sending ? <Spinner className="me-2" as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : <FaSave className="me-2" size={22} /> } {' '}
                                    {display.buttom.save}
                                </Button>}
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    } // viewCadastreForm

    return (
        <>
            { viewCadastreForm() }
        </>
    );

}

export default CommonAreaCondominiumForm;
